module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAuElEQVR4Ae3NgQbDMACE4dvTDIFAIKCwRxkGDAMMfd8RqnQ12MoqTGa7A6i7QCT8HzzP07Z7vo8BAwYMbAM4IsjAHieQOy+JgiABAbfl/QJi1zVSEGkgoKw/BNHXzIBIARGl/vSARqS/QMTA51tiRPoJJDpPEC2QMBJ5gshfgUzmCWJCboCMic8zRPcBdHyeJWZ09X7AzOd54l5vDz7PE+3R8zyh53lCz+sEn9cJPa8Tel4i9LzneS+NFAoavBBivwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Entitytypeview/baseline_arrow_downward_black_24dp.png
// module id = 142
// module chunks = 0